import { render, staticRenderFns } from "./TeishutsuInputPage.vue?vue&type=template&id=edb6e594&scoped=true&"
import script from "./TeishutsuInputPage.vue?vue&type=script&lang=ts&"
export * from "./TeishutsuInputPage.vue?vue&type=script&lang=ts&"
import style0 from "./TeishutsuInputPage.vue?vue&type=style&index=0&id=edb6e594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6e594",
  null
  
)

export default component.exports